'use client';

import { useEffect, useState } from 'react';
import { useSatelliteContext } from '../components/SatelliteProvider';
import { type Auth0PageViewUrlParams } from '../lib/auth0/types';

function isAnalyticsPageViewData(
  event: Event,
): event is Event & { detail: Auth0PageViewUrlParams } {
  return 'detail' in event;
}

export function useSatellitePageView() {
  const [pageView, setPageView] = useState<Auth0PageViewUrlParams | null>(null);
  const { setSegmentPageViewListenerAdded } = useSatelliteContext();

  useEffect(() => {
    function handlePageViewReady(evt: Event) {
      if (isAnalyticsPageViewData(evt)) {
        const pageViewData = evt.detail;
        setPageView(pageViewData);
      }
    }

    document.addEventListener('segment-pageview-ready', handlePageViewReady);
    setSegmentPageViewListenerAdded(true);

    return () => {
      document.removeEventListener('segment-pageview-ready', handlePageViewReady);
      setSegmentPageViewListenerAdded(false);
    };
  }, []);

  return pageView;
}
